import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';
import CaretLink from 'modules/Common/components/CaretLink';
import CompactText from 'modules/Common/components/CompactText';
import { toSlug } from 'utils';

require('./HorseRacingRacecardLastYearsWinners.scss');

export default function HorseRacingRacecardLastYearsWinners(props) {

  const lastYearsWinners = props.lastYearsWinners;
  return ( lastYearsWinners && lastYearsWinners.length ?
              <table className="hr-last-years-winners-table">
                <thead>
                  <tr>
                    <th className="draw-number">DRAW</th>
                    <th className="horse-name">HORSE</th>
                    <th className="horse-age">A</th>
                    <th className="weight">WGT</th>
                    <th className="starting-price">SP</th>
                    <th className="full-result-link"></th>
                  </tr>
                </thead>
                { lastYearsWinners.map(previousWinner => {
                    const {
                        draw_number: drawNumber,
                        horse: {
                          name: horseName,
                          age,
                          horse_reference: {
                            id: horseId
                          } = {}
                        } = {},
                        odds,
                        race_summary: {
                          name: raceName,
                          race_summary_reference: {
                            id: raceId
                          } = {}
                        } = {},
                        weight,
                        jockey: {
                          name: jockeyName,
                          person_reference : {
                            id: jockeyId
                          } = {}
                        } = {},
                        trainer: {
                          name: trainerName,
                          business_reference: {
                            id: trainerId
                          } = {}
                        } = {},
                        meeting_summary: {
                          date: meetingDate,
                          course: {
                            name: courseName
                          } = {}
                        } = {}
                    } = previousWinner;
                    return (
                    <tbody key={`${drawNumber}:${horseName}`}>
                      <tr>
                        <td>{drawNumber}</td>
                        <td>
                        { horseId ?
                          <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link> :
                          horseName
                        }
                        </td>
                        <td>{age}</td>
                        <td>{weight}</td>
                        <td>{odds}</td>
                        <td className="hr-last-years-winners-full-results">
                        { meetingDate && courseName && raceId && raceName &&
                          <CaretLink to={`/racing/results/${meetingDate}/${toSlug(courseName)}/${raceId}/${toSlug(raceName)}`}><CompactText compactText="Result">Full Result</CompactText></CaretLink>
                        }
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                        <span className="hr-last-years-winners-trainer-name">T:&nbsp;
                        { trainerId ?
                          <Link to={`/racing/profiles/trainer/${trainerId}`}>{trainerName}</Link> :
                          trainerName
                        }
                        </span>
                        <span className="hr-last-years-winners-jockey-name">J:&nbsp;
                        { jockeyId ?
                          <Link to={`/racing/profiles/jockey/${jockeyId}`}>{jockeyName}</Link> :
                          jockeyName
                        }
                        </span>
                        </td>
                        <td></td>{/* Empty cell to finish the row */}
                      </tr>
                    </tbody>
                    )
                  })}
              </table>
              :
              <div className="hr-racing-racecard-section-body">
              Last year's winner is unavailable
              </div>
  );
}

HorseRacingRacecardLastYearsWinners.propTypes = {
  lastYearsWinners: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardLastYearsWinners.js